import FuseNavigation from '@fuse/core/FuseNavigation';
import clsx from 'clsx';
import { memo, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectNavigation, updateConnectedNavigation, updateRoofingNavigation, updateSalesAdminNavigation, updateSalesUserNavigation, updateSolarNavigation  } from 'app/store/fuse/navigationSlice';
import { selectUser } from 'app/store/userSlice';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import {CONNECTED_CONTRACTOR, SALES_ONLY_ADMIN, SALES_ONLY_USER} from '../../configs/constants';

function Navigation(props) {
  const navigation = useSelector(selectNavigation);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    if(user && user.account_type && user.account_type == 'Roofing Company'){
      dispatch(updateRoofingNavigation());
    }
    else if(user && user.account_type && user.account_type == CONNECTED_CONTRACTOR){
      dispatch(updateConnectedNavigation());
    }
    else if(user && user.account_type && user.account_type == SALES_ONLY_ADMIN){
      dispatch(updateSalesAdminNavigation());
    }
    else if(user && user.account_type && user.account_type == SALES_ONLY_USER){
      dispatch(updateSalesUserNavigation());
    }
    else{
      dispatch(updateSolarNavigation());
    }
  },[user]);

  return useMemo(() => {
    function handleItemClick(item) {
      if (isMobile) {
        dispatch(navbarCloseMobile());
      }
    }

    return (
      <FuseNavigation
        className={clsx('navigation', props.className)}
        navigation={navigation}
        layout={props.layout}
        dense={props.dense}
        active={props.active}
        onItemClick={handleItemClick}
      />
    );
  }, [dispatch, isMobile, navigation, props.active, props.className, props.dense, props.layout]);
}

Navigation.defaultProps = {
  layout: 'vertical',
};

export default memo(Navigation);
